import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Global } from '../../App';

function StaffOrderStepFrame({ children, ...props }) {
  const { globalState, dispatchGlobal } = useContext(Global);

  return (
    <div className="TakeOrder col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0">
      <div id="staffPageTitle" className="Pages__section d-flex flex-column align-items-center pb-sm-4">
        <div className="Pages__title d-flex">
          <FormattedMessage
            id="pages.staffTakeOrder.title"
            children={e => {
              const { langType } = globalState;
              if (langType !== 'zh' && langType !== 'ja' && langType !== 'ko') {
                const splitString = e.split(' ');
                return splitString.map((e, index) => (
                  <div
                    key={index}
                    className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                  >
                    <div>{e}</div>
                  </div>
                ));
              } else {
                const splitString = e.split('');
                return splitString.map((e, index) => (
                  <div
                    key={index}
                    className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                  >
                    <div>{e}</div>
                  </div>
                ));
              }
            }}
          />
        </div>
      </div>
      <div className="Pages__section d-flex flex-column col p-0">
        {children}
      </div>
    </div>
  );
}

export default StaffOrderStepFrame;
